type Props = {
    ariaAnnounceText: string;
};

// Rounds to nearest single digit, e.g. 1/2/3/4/etc, multiply that by 10 to get 10/20/30/40/etc and subtract 100 to find remaining percentage
const AriaAnnounceProgress = ({ ariaAnnounceText }: Props) => (
    <div className="sr-only" aria-live="polite">
        {ariaAnnounceText}
    </div>
);

export default AriaAnnounceProgress;
